import React from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PrintIcon from '@mui/icons-material/Print';
// or
import QrCodeIcon from '@mui/icons-material/QrCode';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleMatInward } from '../../../Store/PHPSlice/MatInward';
import axios from 'axios';

const TableBody = ({
    id,
    serialNumber,
    dt,
    inwardNo,
    inwardType,
    piNo,
    poId,
    locationNm,
    firmNm,
    canDelete,
    materialNm,
    description,
    size,
    pkt,
    packetqty,
    totqty,
    qty,
    inwardqty,
    selected,
    handleClick,
}) => {
    const userdata = JSON.parse(localStorage.getItem('user'));

    const baseUrl = process.env.REACT_APP_BASE_URL;
    const dispatch = useDispatch();
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open
        window.open(`/MaterialInwardEdit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleViewClick = () => {
        if (inwardType === "Direct Inward") {
            window.open(
                `MaterialInwardView/${inwardNo}/${inwardType}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
        } else if (inwardType === "Purchase Inward") {
            window.open(
                `MaterialInwardView/${poId}/${inwardType}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
        }
    };

    const handleBarcodePrint = () => {
        if (inwardType === "Direct Inward") {
            window.open(
                `MaterialInwardBarcode/${inwardNo}/${inwardType}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
        } else if (inwardType === "Purchase Inward") {
            window.open(
                `MaterialInwardBarcode/${poId}/${inwardType}`, '_blank', 'width=1000,height=700,scrollbars=yes,resizable=yes');
        }
    };

    const handleDeleteClick = async() => {
        const isConfirmed = window.confirm("Are you sure you want to delete this Material Inward?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            var noid = inwardNo;
            if (inwardType === "Purchase Inward") {
                noid = poId
            }

            // dispatch(deleteSingleMatInward(noid, JSON.stringify(inwardType), JSON.stringify(userdata?.ID)))
            //     .then((res) => {
            //         // Reload the page to show updated results
            //         console.log(res);
            //         // toast("Material Inward Deleted Sucessfully");
            //         // window.location.reload();
            //     })
            //     .catch((error) => {
            //         // Handle any errors that occur during the deletion process
            //         console.error("Error deleting Material Inward:", error);
            //         toast.error("Failed to delete Material Inward");
            //     });
            await deleteInwardApiCall(noid, inwardType, userdata?.ID);
        }
    };


    const deleteInwardApiCall = async(inwNo, inwType, userId)=>{
        try {
            const res = await axios.delete(`${baseUrl}?apicall=MaterialInwDeleteApi&inwardNo=${inwNo}&inwardType=${inwType}&userId=${userId}`);

             if (res.data === "success") {
                alert(res.data.msg);
                window.location.reload();
            } else {
                alert(res.data.msg);
            }
        } catch (error) {
            console.error('error', error);
        }
    }


    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{serialNumber}</TableCell>


                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{dt}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{firmNm}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{locationNm}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{inwardType}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{inwardNo}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{piNo}</TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {qty}
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <VisibilityIcon
                        className="cursor-pointer"
                        onClick={handleViewClick}
                    />
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'center' }}>


                        <PrintIcon
                            className="cursor-pointer"
                            onClick={handleBarcodePrint}
                            titleAccess="Print Barcode"
                        />
                    </div>
                </TableCell>
                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className="cursor-pointer" onClick={handleEditClick} />
                </TableCell> */}
                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell> */}


            </TableRow>
            <ToastContainer />
        </>
    );
};

export default TableBody;
